import React from 'react';
import classNames from 'classnames';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const PersonTeaser = ({ id, entity, className }) => {
  const classes = classNames(className);
  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="PersonTeaser News teaser">
        <div className="mb-6">
          <div className="PersonTeaser__image">
            <Image
              src={entity.getIn(['field_image', 0, 'styles', 'employee'])}
              includeWebP
            />
          </div>

          <h3 className="PersonTeaser__title">{entity.getIn(['title', 0, 'value'])}</h3>
          <div>{entity.getIn(['field_job_title', 0, 'value'])}</div>
          {
            entity.getIn(['field_twitter', 0, 'uri']) && (
              <a className="icon icon-x" target="_blank" rel="noopener noreferrer" href={entity.getIn(['field_twitter', 0, 'uri'])}>X</a>
            )
          }
          {
            entity.getIn(['field_linkedin', 0, 'uri']) && (
              <a className="icon icon-linkedin" target="_blank" rel="noopener noreferrer" href={entity.getIn(['field_linkedin', 0, 'uri'])}>Linkedin</a>
            )
          }
        </div>
      </div>
    </article>
  );
};

export default PersonTeaser;
